<iframe [src]="getTokenUrl" style="display:none;" *ngIf="useSSU"></iframe>
